import { getCountryCallingCode, parsePhoneNumberFromString } from "libphonenumber-js/max";
import { resolvePhoneCountry } from "./defaultCountry";

function e164Phone(value) {
  const text = String(value ?? "").trim();
  if (!/^\+[1-9]\d{1,14}$/.test(text)) return null;

  const phone = parsePhoneNumberFromString(text);
  return phone?.isValid() && phone.number === text ? phone : null;
}

export function formatPhone(value) {
  const phone = e164Phone(value);
  if (!phone) return String(value ?? "");

  const formatted = phone.formatInternational();
  return phone.country === "RU"
    ? formatted.replace(/^(\+7 \d{3} \d{3}) (\d{2}) (\d{2})$/, "$1-$2-$3")
    : formatted;
}

export function telHref(value) {
  const phone = e164Phone(value);
  if (phone) return `tel:${phone.number}`;
  return `tel:${String(value ?? "").replace(/[^\d+]/g, "")}`;
}

export function waHref(value, country) {
  const phone = e164Phone(value);
  if (phone) return `https://wa.me/${phone.number.slice(1)}`;

  let digits = String(value ?? "").replace(/\D/g, "");
  if (digits.startsWith("8") && digits.length === 11) {
    digits = `7${digits.slice(1)}`;
  } else if (digits.startsWith("00")) {
    digits = digits.slice(2);
  } else if (digits.startsWith("0") && digits.length >= 10) {
    const iso2 = resolvePhoneCountry(country);
    if (iso2) digits = `${getCountryCallingCode(iso2)}${digits.slice(1)}`;
  }

  return `https://wa.me/${digits}`;
}

// Последние n цифр номера (подсказки в списках «…4567») — по цифрам, не по отформатированной строке.
export function phoneLastDigits(value, n = 4) {
  return String(value ?? "").replace(/\D/g, "").slice(-n);
}
